module.exports = __webpack_public_path__ + "./fonts/main-bold.ttf";